import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  initPasswordRecovery: (email: string, captcha: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation (
          $email: String!
          $captcha: String!
        ) {
          sendPasswordRecoveryEmail(
            email: $email
            captcha: $captcha
          )
        }
      `,
      variables: {
        email,
        captcha,
      },
    }),
    "sendPasswordRecoveryEmail",
  ),

  changePassword: (recoveryToken: string, newPassword: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation (
          $recoveryToken: String!
          $newPassword: String!
        ) {
          resetPassword(
            recoveryToken: $recoveryToken
            newPassword: $newPassword
          )
        }
      `,
      variables: {
        recoveryToken,
        newPassword,
      },
    }),
    "resetPassword",
  ),
})
